import { render, staticRenderFns } from "./set-question.vue?vue&type=template&id=f8acdea0&scoped=true"
import script from "./set-question.vue?vue&type=script&lang=ts"
export * from "./set-question.vue?vue&type=script&lang=ts"
import style0 from "./set-question.vue?vue&type=style&index=0&id=f8acdea0&prod&lang=scss&scoped=true"
import style1 from "./set-question.vue?vue&type=style&index=1&id=f8acdea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8acdea0",
  null
  
)

export default component.exports